<template>
  <list-view-cell :context-menu-items="contextMenuItems">
    <h3 class="font-bold pb-2">{{ item.name }}</h3>
    <p class="text-sm">{{ item.vendorName }}</p>
  </list-view-cell>
</template>

<script>
import { ContextMenuItem } from "../../../helper-classes/ContextMenuItem";
import { Item } from "../../../models/Item";
import ListViewCell from "./ListViewCell";
import ItemForm from "../../../views/items/ItemForm";

export default {
  name: "ItemCell",
  components: { ListViewCell },
  props: {
    item: { type: Item, required: true }
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("edit", () => {
          this.$store.commit("setCreateEditComponentParams", {
            createEditComponent: ItemForm,
            createEditComponentData: this.item,
            createEditComponentIsShown: true
          });
        }),
        new ContextMenuItem("delete", () => {
          console.log("Deleting the item...");
        })
      ]
    };
  }
};
</script>

<style scoped></style>
